import { Link } from 'react-router-dom';

export default function MultilingualSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4">
          日本と海外チームの予定を、ひとつのガントチャートで
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">
          メンバーごとの稼働日や祝日を考慮し、国をまたいだプロジェクトのスケジュール管理を実現します
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto bg-primary-100 rounded-full flex items-center justify-center mb-3">
              <span className="text-primary-700 font-bold text-sm">JP</span>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">日本語</h3>
            <p className="text-xs text-foreground-500">日本の祝日・稼働日に対応</p>
          </div>
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto bg-accent-100 rounded-full flex items-center justify-center mb-3">
              <span className="text-accent-700 font-bold text-sm">EN</span>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">English</h3>
            <p className="text-xs text-foreground-500">国際的な祝日・稼働日に対応</p>
          </div>
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto bg-secondary-100 rounded-full flex items-center justify-center mb-3">
              <span className="text-secondary-700 font-bold text-sm">TH</span>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-2">ภาษาไทย</h3>
            <p className="text-xs text-foreground-500">タイの祝日・稼働日に対応</p>
          </div>
        </div>

        <div className="bg-background-100 rounded-lg p-8 border border-background-200/70 max-w-[800px] mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center shrink-0">
              <i className="ri-calendar-check-line text-accent-600 text-lg"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">国別祝日を考慮したスケジュール管理</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                メンバーごとに所属国や利用言語を設定できます。日本の祝日には日本メンバーを休みにし、タイの祝日にはタイメンバーを休みにするといった日程管理が可能です。AIが各メンバーの稼働日を自動で計算し、期限やスケジュールに反映します。
              </p>
              <Link to="/features/multilingual/" className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 hover:text-primary-700">
                詳しく見る <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}